<template>
    <b-overlay :show="loading" rounded="sm">
    <div>
        <b-modal id="modal-customer-user" header-class="p-0" footer-class="d-flex justify-content-center border-0"
            content-class="custom-model-wrap" @ok="handleOk">
            <template #modal-header="{ cancel }">
                <div class="title-block text-center p-2">
                    {{ !!userModel.id ? $translate('edit_user') : $translate("add_user") }}
                </div>
                <button class="close" @click="cancel()">x</button>
            </template>
            <template #default>
                <b-form ref="contactForm" @submit.stop.prevent="handleSubmit">
                    <b-row>
                        <b-col cols="12">
                            <label class="mb-3"><strong>{{ $translate('email') }}<span class="red">{{
                                userModel.is_blacklisted
                                ? '' : '*'
                            }}</span></strong></label>
                            <b-form-input id="input-email" v-model="displayEmail" type="email"
                                :placeholder="$translate('enter_email')"
                                :required="isEmailViewOnly || !userModel.is_blacklisted"
                                :disabled="!isEmailViewOnly && !!userModel.id"
                                v-custom-validation="(isEmailViewOnly || !userModel.is_blacklisted) ? $textRequired() : ''"></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly && isAccountAdmin">
                            <div class="d-flex align-items-center justify-content-end flex-row-reverse gap-2">
                                <label for="input-is_blacklisted" class="mt-0 mt-md-2"><strong>{{
                                    $translate('customer_portal_access') }}</strong></label>
                                <div class="form-check me-2">
                                    <label class="form-check-label">
                                        <b-form-checkbox id="input-is_blacklisted" v-model="is_blacklisted"
                                            name="input-is_blacklisted" :value="false" :unchecked-value="true"
                                            :disabled="isDummyEmail">
                                        </b-form-checkbox>
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </div>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('phone') }}</strong></label>

                            <b-form-input id="input-phone" v-model="userModel.phone" type="number"
                                :placeholder="$translate('enter_phone')"></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('first_name') }}<span
                                        class="red">*</span></strong></label>
                            <b-form-input id="input-2" v-model="userModel.first_name"
                                :placeholder="$translate('enter_first_name')" required
                                v-custom-validation="$textRequired()"></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('last_name') }}<span
                                        class="red">*</span></strong></label>
                            <b-form-input id="input-last-name" v-model="userModel.last_name"
                                :placeholder="$translate('enter_last_name')" required
                                v-custom-validation="$textRequired()"></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-2"><strong> {{ $translate('role') }}<span class="red">*</span></strong></label>
                            <b-form-select class="form-control" id="input-portal_role_id" required
                                v-custom-validation="$selectRequired()" :disabled="isDisabled"
                                v-model="userModel.portal_role_id" :options="portalRoles" text-field="name" value-field="id"
                                trim>
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_role')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('position') }}</strong></label>
                            <b-form-input id="input-position" v-model="userModel.position"
                                :placeholder="$translate('enter_position')"></b-form-input>
                        </b-col>
                        <b-col class="mt-3" cols="12" v-if="!isEmailViewOnly">
                            <label class="mb-3"><strong>{{ $translate('remarks') }}</strong></label>
                            <b-form-textarea id="input-remarks" v-model="userModel.remarks"
                                :placeholder="$translate('enter_remarks')" rows="3" max-rows="6"></b-form-textarea>
                        </b-col>
                    </b-row>
                </b-form>
            </template>
            <template #modal-footer="{ ok, cancel }">
                <b-button v-if="!!userModel.id" size="fw" variant="info" @click="isEmailViewOnly = !isEmailViewOnly">
                    {{ isEmailViewOnly ? $cancelLabel() : $translate('change_email') }}
                </b-button>
                <b-button :disabled="loading" variant="info" size="fw" @click="ok()">
                    {{ submitLabel }}
                </b-button>
                <b-button size="fw" v-if="!isEmailViewOnly &&
                    !!userModel.id && isAccountAdmin" variant="delete-button" @click="deleteUser(userModel.id)">
                    {{ $deleteLabel() }}
                </b-button>
                <b-button size="fw" variant="info" @click="
                    isEmailViewOnly = false
                cancel()
                    " v-if="!isEmailViewOnly">
                    {{ $cancelLabel() }}
                </b-button>
            </template>
        </b-modal>
        <b-card body-class="px-0" class="border-0" :style="customColor">
            <div class="d-flex title-bar-block mb-2">
                <div class="icon-block me-4">
                    <button @click="cancel()"><i class="fa fa-chevron-left text-white" aria-hidden="true"></i></button>
                </div>
                <div class="text">
                    <span class="me-2">{{ $translate('users') }}</span>
                </div>
            </div>
            <div class="text-end">
                <b-button v-if="isAccountAdmin" @click="viewAddCustomer()" variant="info">{{ $translate('add_user')
                }}</b-button>
            </div>
            <b-col class="page-block" :style="customColor"><strong> {{ $translate('page') }}: {{ currentPage }}
                    {{ $translate('of') }}
                    {{ Math.ceil(rows / itemsPerPage) }} {{ $translate('total') }}:
                    {{ rows }}</strong></b-col>
            <b-col class="overflow-auto w-100 mt-4">
                <!-- <b-table hover :fields="fields" :items="contacts" :per-page="itemsPerPage" responsive
                    :current-page="currentPage">
                    <template #cell(actions)="{ item }">
                        <b-button variant="pink-button" class="mr-2"
                            @click="viewCustomer(item)">
                            <img src="@/assets/images/icon/view.svg" />
                        </b-button>
                    </template>
                </b-table> -->
                <div class="table-responsive">
                    <table class="table b-table" :style="customColor">
                        <thead>
                            <th v-for="item in fields" :key="item.id">{{ item.label }}</th>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in contacts" :key="item.id">
                                <td aria-colindex="1">
                                    <b-button @click="viewCustomer(item, index)" class="mr-2" variant="pink-button">
                                        <img src="@/assets/images/icon/view.svg" />
                                    </b-button>
                                </td>
                                <td>{{ item.user.first_name }}</td>
                                <td aria-colindex="2">
                                    {{ item.user.last_name }}
                                </td>
                                <td aria-colindex="2">
                                    {{ item.user.email }}
                                </td>
                                <td aria-colindex="2">
                                    {{ getroleName(item.portal_role_id) }}
                                </td>
                                <td aria-colindex="2">
                                    {{ item.user.phone }}
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-col>
            <b-row>
                <b-col>
                    <b-pagination class="float-right mt-4" v-model="currentPage" :total-rows="rows"
                        :next-text="$translate('next')" :prev-text="$translate('previous')" :per-page="itemsPerPage"
                        aria-controls="roleTable" pills align="center"></b-pagination>
                </b-col>
            </b-row>
        </b-card>
    </div>
    </b-overlay>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'

const userModel = Object.freeze({
    first_name: null,
    last_name: null,
    portal_role_id: null,
    email: null,
    phone: null,
    id: null,
    remarks: null,
})
export default {
    name: 'progressStatus-ViewItem',
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            userModel: {
            },
            itemsPerPage: 15,
            currentPage: 1,
            isEmailViewOnly: false,
            isDisabled: false,
            loading: false,
            hasErrors: false,
            portalRoles: [
                { id: 1, name: 'Account Admin' },
                { id: 2, name: 'Regular User' },
                { id: 3, name: 'No Access' }
            ],
        }
    },
    props: ['value', 'submitting'],
    computed: {
        customColor() {
            const data = this.$store.state.company.settings || {}
            const colors = {
                'background-color': data.background_color + "!important",
                color: data.text_color + "!important"
            }
            return colors
        },
        isAccountAdmin() {
            const user_id = this.$store.state.user.id
            const loggedUser = this.$store.getters['customers/customerPortalUsers'].filter(x => x.user_id == user_id)
            const accountAdminRole = this.portalRoles.filter(x => x.name == "Account Admin")
            console.log('loggedUser', loggedUser, accountAdminRole)
            return loggedUser && loggedUser[0] && (loggedUser[0].portal_role_id === accountAdminRole[0].id || loggedUser[0].portal_role_id == null)
        },
        rows() {
            return this.contacts.length
        },

        fields() {
            const { dummyEmailSuffix } = this
            return [
                // { label: 'Actions', key: 'actions' },
                {
                    key: 'actions',
                    label: this.$translate('actions'),
                    formatter: (value, key, item) => item.user.id
                    // formatter: (value, key, item) => console.log("itemmmmmm",item) 
                },
                {
                    key: 'first_name',
                    label: this.$translate('first_name'),
                    formatter: (value, key, item) => item.user.first_name
                    // formatter: (value, key, item) => console.log("itemmmmmm",item) 
                },
                {
                    key: 'last_name',
                    label: this.$translate('last_name'),
                    formatter: (value, key, item) => item.user.last_name
                    // formatter: (value, key, item) => console.log("itemmmmmm",item) 
                },
                {
                    key: 'email',
                    label: this.$translate('email'),
                    formatter: (value, key, item) =>
                        (item.user.email || '').indexOf(dummyEmailSuffix) >= 0
                            ? ''
                            : item.user.email,
                },
                {
                    key: 'portal_role_id',
                    label: this.$translate('role'),
                    formatter: value =>
                        this.getroleName(value)
                    // formatter: (value, key, item) => console.log("itemmmmmm",item) 
                },
                {
                    key: 'phone',
                    label: this.$translate('phone'),
                    formatter: (value, key, item) => item.user.phone

                }


            ]
        },
        is_blacklisted: {
            set(value) {
                this.$set(this.userModel, 'is_blacklisted', value ? 1 : 0)
            },
            get() {
                return this.isDummyEmail
                    ? true
                    : !!this.userModel.is_blacklisted
            },
        },
        displayEmail: {
            set(value) {
                this.$set(this.userModel, 'email', value)
            },
            get() {
                const {
                    isDummyEmail,
                    userModel: { email },
                    isEmailViewOnly,
                } = this
                return isDummyEmail && isEmailViewOnly
                    ? ''
                    : isDummyEmail
                        ? '------'
                        : email
            },
        },
        submitLabel() {
            if (this.loading && this.userModel.id) {
                return this.$translate('updating')
            } else if (this.loading) {
                return this.$translate('creating')
            } else if (this.userModel.id) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },
        isDummyEmail() {
            return (
                (this.userModel.email || '').indexOf(this.dummyEmailSuffix) >= 0
            )
        },


        model: {
            get() {
                console.log('', this.value)
                return this.value
            },
        },
        contacts() {
            const user_id = this.$store.state.user.id
            return this.$store.getters['customers/customerPortalUsers'].filter(x => x.user_id !== user_id)
        },
        customer() {
            const customer = this.$store.state.customers.item
            if (customer == null) {
                return ''
            } else {
                return customer
            }
        },
    },
    watch: {
        contacts: {
            immediate: true,
            handler: function () {

            },
            deep: true,
        },
    },
    mounted() {
        const customer_id = this.$store.state.user.customers[0].customer_id
        this.$store.dispatch('customers/fetchById', customer_id)
        this.$root.$on('bv::modal::show', () => {
            this.isEmailViewOnly = false
            console.log()
            if (this.contacts.length == 0) {
                this.$set(this.userModel, 'role_id', 1)
            }
        })
    },
    methods: {
        cancel() {
            this.$router.push('/customer-portal/service-requests')
        },
        getroleName(portal_role_id) {
            const roleData = this.portalRoles.find(x => x.id == portal_role_id)
            return roleData && roleData.name
        },
        viewCustomer(data) {
            console.log("index")
            this.userModel = { ...userModel, ...(data.user || {}) }
            this.userModel.portal_role_id = data.portal_role_id
            this.$bvModal.show('modal-customer-user')
        },
        viewAddCustomer(data) {
            this.userModel = { ...userModel, ...(data || {}) }
            this.$bvModal.show('modal-customer-user')
        },
        checkFormValidity() {
            const valid = this.$refs.contactForm.checkValidity()
            return valid
        },
        async deleteUser(user_id) {
            try {
                const title = this.$translate('delete_customer_note')
                const message = `${this.$translate('delete_note')} the Contact?`
                const result = await this.confirmMessage(title, message)
                if (!result) throw new Error(this.$translate('cancel_delete'))

                const {
                    customer: { id: customer_id },
                } = this
                this.loading = true
                await this.$store.dispatch('customers/deleteUser', {
                    customer_id,
                    user_id,
                })
                this.doToast(this.$translate('contact_deleted'), this.$translate('deleted'), 'success')
                this.$bvModal.hide('modal-customer-user')
            } catch (err) {
                console.log('err', err)
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.loading = false
            }
        },
        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.$refs.contactForm.requestSubmit()
        },

        async handleSubmit() {
            try {
                if (!this.checkFormValidity()) {
                    throw new Error(this.$translate('not_validated'))
                }
                this.loading = true
                console.log("1", this.userModel)
                const {
                    customer: { id: customer_id },
                    userModel: data,
                    isDummyEmail,
                    isEmailViewOnly,
                } = this
                console.log("2", this.userModel)
                const isNew = !data.id
                if (isEmailViewOnly) {
                    const { id: userId, email } = data
                    await this.$store.dispatch('users/updateEmail', {
                        userId,
                        email,
                    })
                    await this.$store.dispatch(
                        'customers/fetchById',
                        customer_id
                    )
                } else {
                    if (isDummyEmail) {
                        data.is_blacklisted = 1
                    }

                    console.log('data', data)
                    if (data.is_blacklisted && !data.email) {
                        data.email = this.calculateDummyEmailAddress()
                    }
                    const path = `customers/${isNew ? 'createUser' : 'updateUser'
                        }`
                    await this.$store.dispatch(path, {
                        customer_id,
                        data,
                    })
                }

                if (isNew) {
                    this.doToast(this.$translate('contact_created'), this.$translate('created'), 'success')
                } else {
                    this.doToast(this.$translate('contact_updated'), this.$translate('updated'), 'success')
                }

                this.$nextTick(() => {
                    this.$bvModal.hide('modal-customer-user')
                })
            } catch (error) {
                const emailError = this.$translate('data_was_invalid')
                if (error.response) {
                    // Request made and server responded
                    console.log('error.response')
                    console.log(error.response.data)
                    console.log(error.response.status)
                    console.log(error.response.headers)
                    this.doToast(
                        this.$translate('error'),
                        error.response.data.message,
                        'danger'
                    )
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log('error.request')
                    console.log(error.request)
                    this.doToast(
                        this.$translate('system_error_detected'),
                        this.$translate('contact_administrator'),
                        'danger'
                    )
                } else {
                    // Something happened in setting up the request that triggered an Error
                    let errorMessage = error.message

                    if (errorMessage == emailError) {
                        errorMessage = this.$translate('email_already_used')
                    }
                    console.log('Error', error.message)
                    this.doToast(this.$translate('error'), errorMessage, 'danger')
                }
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
